import { Receipt, ShoppingBag } from 'lucide-react';
import type { FeatureManifest } from '@/app/registry';
import { CONTEXTS, lazyView } from '@/app/registry';
import { purchasesRoutes } from './routes';
import { PURCHASES_PATHS } from './constants';

export const purchasesManifest: FeatureManifest = {
  id: 'purchases',
  contexts: [
    CONTEXTS.PURCHASES,
    CONTEXTS.PURCHASES_COMPLETE,
    CONTEXTS.PURCHASES_PACK_EVAL,
    CONTEXTS.PURCHASES_HISTORY,
    CONTEXTS.PAYMENT_SUCCESS,
    CONTEXTS.PAYMENT_CANCEL,
  ],

  routes: [
    {
      zone: 'authenticated',
      routes: purchasesRoutes,
      errorFallbackLabel: 'Mes achats',
    },
  ],

  centerView: {
    [CONTEXTS.PURCHASES]: lazyView(() => import('./views/PurchasesView'), 'PurchasesView'),
    [CONTEXTS.PURCHASES_COMPLETE]: lazyView(() => import('./views/CompleteView'), 'CompleteView'),
    [CONTEXTS.PURCHASES_PACK_EVAL]: lazyView(() => import('./views/PackEvalView'), 'PackEvalView'),
    [CONTEXTS.PURCHASES_HISTORY]: lazyView(
      () => import('./views/MyPurchasesView'),
      'MyPurchasesView',
    ),
    [CONTEXTS.PAYMENT_SUCCESS]: lazyView(
      () => import('./views/PaymentSuccessView'),
      'PaymentSuccessView',
    ),
    [CONTEXTS.PAYMENT_CANCEL]: lazyView(
      () => import('./views/PaymentCancelView'),
      'PaymentCancelView',
    ),
  },

  navigation: [
    {
      id: 'purchases',
      label: 'Boutique',
      icon: ShoppingBag,
      to: PURCHASES_PATHS.root,
      position: 'bottom',
      order: 20,
      pulse: true,
      // Sans liste explicite, les deux liens hériteraient de tous les `contexts`
      // de la feature et s'allumeraient ensemble. « Mes achats » a la sienne.
      activeContexts: [
        CONTEXTS.PURCHASES,
        CONTEXTS.PURCHASES_COMPLETE,
        CONTEXTS.PURCHASES_PACK_EVAL,
        CONTEXTS.PAYMENT_SUCCESS,
        CONTEXTS.PAYMENT_CANCEL,
      ],
    },
    {
      id: 'purchases-history',
      label: 'Mes achats',
      icon: Receipt,
      to: PURCHASES_PATHS.history,
      position: 'bottom',
      order: 21,
      activeContexts: [CONTEXTS.PURCHASES_HISTORY],
    },
  ],
};
